import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-minimal-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './minimal-template.component.html',
  styleUrl: './minimal-template.component.scss'
})
export class MinimalTemplateComponent {


  @Input() data!: ResumeDataByID;
    @Input() color: string = '#000';
    @Input() font: string = '';

}
